import { render } from "./index.vue?vue&type=template&id=659388f0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=659388f0&scoped=true&lang=less"

import exportComponent from "D:\\Git仓库\\象新力官网\\html_xxldx_xxlx_xxlg\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-659388f0"]])

export default __exports__